import { render, staticRenderFns } from "./Act1.vue?vue&type=template&id=a94ce208&scoped=true"
import script from "./Act1.vue?vue&type=script&lang=js"
export * from "./Act1.vue?vue&type=script&lang=js"
import style0 from "./Act1.vue?vue&type=style&index=0&id=a94ce208&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94ce208",
  null
  
)

export default component.exports